/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Coco Jinjo (https://sketchfab.com/CocoJinjo)
license: CC-BY-NC-4.0 (http://creativecommons.org/licenses/by-nc/4.0/)
source: https://sketchfab.com/3d-models/just-a-hungry-cat-97913cc5c44e4e6793385b988aac97c1
title: Just a Hungry Cat
import { useGLTF, useAnimations } from '@react-three/drei'
  const { nodes, materials, animations } = useGLTF('/scene.gltf')
  const { actions } = useAnimations(animations, group)
*/

import React, { useRef } from 'react'
import { useGLTF} from '@react-three/drei'

export function Cat(props) {
  const group = useRef()
  const { nodes, materials} = useGLTF('/scene.gltf')
 
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="Sketchfab_model" rotation={[-Math.PI / 2.3, 0, 0]} scale={14}>
          <group name="f79f7555c3984e97ac2ccfa0d0b97585fbx" rotation={[Math.PI / 1.7, 0, 0]} scale={0.01}>
            <group name="Object_2">
              <group name="RootNode">
                <group name="polySurface8" position={[-0.5, 0.3, 0.71]} scale={[1, 1, 1]}>
                  <group name="Cat_Eye_R" position={[-2.41, 12.86, 4.71]}>
                    <mesh name="Cat_Eye_R_M_Cat_Black_0" geometry={nodes.Cat_Eye_R_M_Cat_Black_0.geometry} material={materials.M_Cat_Black} />
                    <mesh name="Cat_Eye_R_M_Cat_Yellow_0" geometry={nodes.Cat_Eye_R_M_Cat_Yellow_0.geometry} material={materials.M_Cat_Yellow} />
                  </group>
                  <group name="Cat_Eye_L" position={[2.41, 12.86, 4.71]}>
                    <mesh name="Cat_Eye_L_M_Cat_Yellow_0" geometry={nodes.Cat_Eye_L_M_Cat_Yellow_0.geometry} material={materials.M_Cat_Yellow} />
                    <mesh name="Cat_Eye_L_M_Cat_Black_0" geometry={nodes.Cat_Eye_L_M_Cat_Black_0.geometry} material={materials.M_Cat_Black} />
                  </group>
                  <group name="Cat_Tail" position={[3.49, 1.26, -3.69]} rotation={[-0.59, 0.2, -0.05]}>
                    <mesh name="Cat_Tail_M_Cat_Body_0" geometry={nodes.Cat_Tail_M_Cat_Body_0.geometry} material={materials.M_Cat_Body} />
                  </group>
                  <group name="Cat_Mustache_1" position={[4.8, 10.21, 2.87]} rotation={[-0.02, -0.01, 0.1]}>
                    <mesh name="Cat_Mustache_1_M_Cat_Body_0" geometry={nodes.Cat_Mustache_1_M_Cat_Body_0.geometry} material={materials.M_Cat_Body} />
                  </group>
                  <group name="Cat_Mustache_2" position={[-4.8, 10.21, 2.87]}>
                    <mesh name="Cat_Mustache_2_M_Cat_Body_0" geometry={nodes.Cat_Mustache_2_M_Cat_Body_0.geometry} material={materials.M_Cat_Body} />
                  </group>
                  <group name="Cat_Mustache_3" position={[-4.71, 10.5, 2.88]}>
                    <mesh name="Cat_Mustache_3_M_Cat_Body_0" geometry={nodes.Cat_Mustache_3_M_Cat_Body_0.geometry} material={materials.M_Cat_Body} />
                  </group>
                  <group name="Cat_Mustache_4" position={[4.71, 10.5, 2.88]}>
                    <mesh name="Cat_Mustache_4_M_Cat_Body_0" geometry={nodes.Cat_Mustache_4_M_Cat_Body_0.geometry} material={materials.M_Cat_Body} />
                  </group>
                  <group name="Cat_Body">
                    <mesh name="Cat_Body_M_Cat_Pink_0" geometry={nodes.Cat_Body_M_Cat_Pink_0.geometry} material={materials.M_Cat_Pink} />
                    <mesh name="Cat_Body_M_Cat_Body_0" geometry={nodes.Cat_Body_M_Cat_Body_0.geometry} material={materials.M_Cat_Body} />
                  </group>
                  <group name="transform1" />
                </group>
                <group name="Background" position={[0, 0.02, 0]} rotation={[0.03, 0, 0]} scale={15.84}>
                  <mesh name="Background_M_BackGround_0" geometry={nodes.Background_M_BackGround_0.geometry} material={materials.M_BackGround} />
                </group>
                <group name="Ground" scale={14.67}>
                  <mesh name="Ground_M_Floor_0" geometry={nodes.Ground_M_Floor_0.geometry} material={materials.M_Floor} />
                </group>
               
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/scene.gltf')
